import {
    polarPayment,
    paypalUrl,
    pclClientId
} from '../api/apiConstants'
import { SET_PAYMENT_LOADER, SET_NOTIFICATION_BANNER } from './actionTypes'
import { postData } from '../utils/spaUtils'
import { setCartData } from './reservation.actions'
import { setPayer, setScreenLoading, addReservations } from './spaServices.actions'
import * as servicesHelpers from './helpers/servicesActionHelper'

export const handlePayment = (cardData) => {
    return  (dispatch, getState) => {
        let { services } = getState()
        let { payer = {} } = services;
        payer.cardStringType = cardData.cardStringType
        payer.CardCode = cardData.CardCode
        payer.CardNumber = cardData.CardNumber
        payer.maskedCardNumber = cardData.maskedCardNumber
		payer.fundsType = cardData.fundsType
		payer.cardType = cardData.cardType
        dispatch(setPayer(payer))
        dispatch(addSpaPaymentPolar())
    }
}

export const addSpaPaymentPolar = () => {
    return async (dispatch, getState) => {
        let { reservations, services } = getState(),
            { cart } = reservations,
            _reqbody = servicesHelpers.getPolarPaymentReq(services, cart);
        // cartPrice =
        //     !cart || cart.length === 0
        //         ? 0
        //         : cart.reduce(
        //               (sum, cartItem) => sum + cartItem.treatmentPrice,
        //               0
        //           )
        let reqHeader = {}
        let { PaymentDetails = {} } = services;
        let { ShipboardCurrencyCode = 'USD' } = PaymentDetails;
        reqHeader.AuthToken = services.authDetails.AuthToken
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId

        let url = `${polarPayment}?vesselId=${services.bookingDetails.vesselId}`;
        dispatch(setScreenLoading(true));
        const response = await postData(url, _reqbody, reqHeader)

        if (!response.ok) {
            dispatch(setScreenLoading(false));
            dispatch(setNotificationBanner('Payment Failed. Please Try Again', 'fail'))
        }
        let payload = response.json()
        payload.then((response) => {
            //console.log(response);
            let result = servicesHelpers.processPaymentResponse(response, cart, dispatch);
            if (result.status === 'Success') {
                dispatch(setPaymentLoader(false))
                dispatch(paymentSuccess(cart, ShipboardCurrencyCode))
                dispatch(setScreenLoading(false));
                dispatch(addReservations(_reqbody.POLARRequest));
            } else {
                if (result.type === 'POLAR_FAILURE') {
                    dispatch(setPaymentLoader(false))
                    dispatch(setPayer({}));
                    dispatch(setScreenLoading(false));
                    dispatch(setNotificationBanner(result.msg, 'fail'))
                }
                else if (result.type === 'OSW_PAR_FAILURE') {
                    dispatch(setPaymentLoader(false))
                    dispatch(setScreenLoading(false));
                    dispatch(setPayer({}));
                    dispatch(setNotificationBanner(result.msg, 'fail'))
                } else {
                    dispatch(setPaymentLoader(false))
                    dispatch(setScreenLoading(false));
                    dispatch(setPayer({}));
                    dispatch(setNotificationBanner('Payment Failed. Please Try Again', 'fail'))
                }
            }

            // let Advisory =
            //     response.POLARResponse.RespMsgHeader.RespStatus.Advisory[0]
            // if (response && Advisory.ReasonCode === '00000') {

            // } else {
            //     let bannerText = Advisory.ReasonText || 'Payment is not successfull'

            // }
        })
    }
}

export const setPaymentLoader = (isLoading) => {
    return {
        type: SET_PAYMENT_LOADER,
        isPayLoading: isLoading,
    }
}

export const handlePayPalPayment = () => {
    return async (dispatch, getState) => {
        //Generating Client Token for Paypal
        dispatch(setScreenLoading(true));
        let paypalTokenUrl = paypalUrl;
        const response = await fetch(paypalTokenUrl, {
            method: 'GET',
        });

        let { services, reservations } = getState()
        let { cart = [] } = reservations;
        let { PaymentDetails = {} } = services;
        let { ShipboardCurrencyCode = 'USD' } = PaymentDetails;
        let cartPrice = (!cart || cart.length === 0)
            ? 0
            : cart.reduce((sum, cartItem) => sum + cartItem.treatmentPrice, 0)

        if (!response.ok) {
            console.log('Error While fetching paypal Token');
            dispatch(setScreenLoading(false));

            return;
        }

        let payload = response.json()
        if (!response.clientToken) {
            console.log('Error While fetching paypal Token');
            dispatch(setScreenLoading(false));
        }
        payload.then((response) => {
            if (response.clientToken) {
                initPayPalConfig(response.clientToken, dispatch, cartPrice, ShipboardCurrencyCode)
                setTimeout(() => {
                    if (checkout) {
                        checkout.paypal.initAuthFlow();
                        dispatch(setScreenLoading(false));

                    }
                }, 3000);
            }
        })
        dispatch(setScreenLoading(false));
    }
}

var checkout;
var sessionCounter = 0;
export const initPayPalConfig = (clientToken, dispatch, cartPrice, ShipboardCurrencyCode) => {

    if (checkout) {
        checkout.teardown(function () {
            console.log("-----|| Teardown initiated!");
            checkout = null;
            sessionCounter = 0;
        });
    }
    // eslint-disable-next-line no-undef
    braintree.setup(clientToken, 'custom', {
        onReady: function (integration) {
            checkout = integration
        },
        onPaymentMethodReceived: (payload) => {
            sessionCounter++;
            if (sessionCounter <= 1) {
                dispatch(setPaypalPaymentInfo(payload))
                dispatch(addSpaPaymentPolar())
            }
        },
        onAuthorizationDismissed: function (ec) {
            console.log('CANCELL CALLED >>')
        },
        onError: function (er) {
            console.log('ERROR-PP >> %o', er)
        },
        paypal: {
            singleUse: true,
            enableShippingAddress: true,
            enableBillingAddress: true,
            headless: true,
            displayName: 'Princess Cruises',
            currency: ShipboardCurrencyCode,
            amount: cartPrice,
        },
    })
}

export const setPaypalPaymentInfo = (payPalPayInfo) =>
    ({
        type: 'SET_PAYPAL_INFO',
        payPalPayInfo
    });

export const paymentSuccess = (cart, ShipboardCurrencyCode) => {
    return  (dispatch) => {
        let cartPrice =
            !cart || cart.length === 0
                ? 0
                : cart.reduce(
                    (sum, cartItem) => sum + cartItem.treatmentPrice,
                    0
                )
        let bannerText = `Your payment of ${ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'}${cartPrice} has been received. Thank You`
        dispatch(setCartData([]))
        // dispatch(getReservedServices(reservedServices))
        dispatch(setNotificationBanner(bannerText, 'success'))
    }
}

export const processPaymentResponse = (response) => { }

export const setNotificationBanner = (bannerText, type) => {
    return {
        type: SET_NOTIFICATION_BANNER,
        notification: {
            bannerText,
            type,
        },
    }
}
